var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"100px"}},[_vm._v("\n  Kmalu na Hitri račun...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }